import React from 'react'
// import { Person } from '@mui/icons-material';
// import MainHeader from '../../components/global/MainHeader'
import WrapperSection from '../../components/global/WrapperSection'
import GlobalBreadcrumbs from '../../components/global/GlobalBreadcrumbs';
import UsersTable from '../../components/Users/UsersTable';

const Users = () => {
    return (
        <>
            <WrapperSection>
                <GlobalBreadcrumbs />
                {/* data table users */}
                <UsersTable />
            </WrapperSection>
        </>
    )
}

export default Users